import { CommandBase } from '@shared/commands/command-base';
import {StreamsConfig} from '../streams.config';
import {PaymentStream} from '../../models/payment-stream.model';

export class AddStreamsCommand extends CommandBase {
  constructor (public streams: PaymentStream[]) {
    super(StreamsConfig.AddStreamsApi);
    this.projectId = '[PROJECT_ID]';
  }
}

export class DeleteStreamsCommand extends CommandBase {
  constructor (public streamIds: string[]) {
    super(StreamsConfig.DeleteStreamsApi);
    this.projectId = '[PROJECT_ID]';
  }
}
